import * as React from 'react'

import { Box, Spinner } from '@factorialco/deprecated-design-system'

import Telemetry from 'modules/core/components/Telemetry'

interface Props {
  expand?: boolean
  inline?: boolean
}

const Loading = ({ inline, expand }: Props) => {
  return (
    <Box
      width="full"
      alignItems="center"
      justifyContent="center"
      height={expand ? 'full' : undefined}
      paddingX={inline ? 's0' : 's48'}
      paddingY={inline ? 's0' : 's48'}
    >
      <Spinner />
    </Box>
  )
}

type TelemetryProps = Props & {
  intent: string
}

Loading.WithTelemetry = function WithTelemetry({ intent, inline, expand }: TelemetryProps) {
  return (
    <Telemetry intent={intent}>
      <Loading inline={inline} expand={expand} />
    </Telemetry>
  )
}

export default Loading
